/**
 * @copyright 汽车商贸管理平台 V1.0
 * @year 2026
 * @file baseURL.js
 */
const getBaseUrl = () => {
  return '' // 始终使用相对路径，由 Nginx 反向代理 /api 到后端
}

const baseUrl = getBaseUrl()
export default baseUrl

/**
 * 本地开发：使用 vue.config.js 的 proxy 代理
 * 手机访问：直接连后端 https://IP:5001
 */